import IslandLabel from "./island_label.svg";

const PythonIsland = ({ x, y, styles, scale = 1 }) => (
  <svg
    x={x}
    y={y}
    width={scale * 247}
    height={scale * 307}
    viewBox="0 0 246 307"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-11"
      maskUnits="userSpaceOnUse"
      x="-0.310547"
      y="60.0629"
      width="247"
      height="247"
      fill="black"
    >
      <rect fill="white" x="-0.310547" y="60.0629" width="247" height="247" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.698 68.0629C168.212 68.0629 161.333 74.9417 161.333 83.4273V144.885H23.0538C14.5683 144.885 7.68945 151.764 7.68945 160.249V283.164C7.68945 291.65 14.5683 298.529 23.0539 298.529H222.791C231.276 298.529 238.155 291.65 238.155 283.164V167.953C238.155 167.946 238.155 167.939 238.155 167.931L238.155 160.249L238.155 83.4273C238.155 74.9417 231.276 68.0629 222.791 68.0629H176.698Z"
      />
    </mask>
    <path
      d="M161.333 144.885V152.567H169.016V144.885H161.333ZM238.155 167.931H245.838V167.931L238.155 167.931ZM238.155 160.249H230.473V160.249L238.155 160.249ZM238.155 83.4273L245.838 83.4273V83.4273H238.155ZM169.016 83.4273C169.016 79.1845 172.455 75.7451 176.698 75.7451V60.3807C163.969 60.3807 153.651 70.699 153.651 83.4273H169.016ZM169.016 144.885V83.4273H153.651V144.885H169.016ZM23.0538 152.567H161.333V137.203H23.0538V152.567ZM15.3716 160.249C15.3716 156.006 18.8111 152.567 23.0538 152.567V137.203C10.3256 137.203 0.00725651 147.521 0.00725651 160.249H15.3716ZM15.3716 283.164V160.249H0.00725651V283.164H15.3716ZM23.0539 290.847C18.8111 290.847 15.3716 287.407 15.3716 283.164H0.00725651C0.00725651 295.893 10.3256 306.211 23.0539 306.211V290.847ZM222.791 290.847H23.0539V306.211H222.791V290.847ZM230.473 283.164C230.473 287.407 227.034 290.847 222.791 290.847V306.211C235.519 306.211 245.838 295.893 245.838 283.164H230.473ZM230.473 167.953V283.164H245.838V167.953H230.473ZM230.473 167.931C230.473 167.93 230.473 167.93 230.473 167.934C230.473 167.937 230.473 167.945 230.473 167.953H245.838C245.838 167.954 245.838 167.955 245.838 167.95C245.838 167.947 245.838 167.94 245.838 167.931H230.473ZM230.473 160.249L230.473 167.931L245.838 167.931L245.838 160.249L230.473 160.249ZM230.473 83.4273L230.473 160.249H245.838L245.838 83.4273L230.473 83.4273ZM222.791 75.7451C227.034 75.7451 230.473 79.1845 230.473 83.4273H245.838C245.838 70.699 235.519 60.3807 222.791 60.3807V75.7451ZM176.698 75.7451H222.791V60.3807H176.698V75.7451Z"
      fill="#0273F5"
      mask="url(#path-1-outside-11)"
    />
    <mask id="path-3-inside-22" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.698 68.0629C168.212 68.0629 161.333 74.9417 161.333 83.4273V144.885H23.0538C14.5683 144.885 7.68945 151.764 7.68945 160.249V283.164C7.68945 291.65 14.5683 298.529 23.0539 298.529H222.791C231.276 298.529 238.155 291.65 238.155 283.164V167.953C238.155 167.946 238.155 167.939 238.155 167.931L238.155 160.249L238.155 83.4273C238.155 74.9417 231.276 68.0629 222.791 68.0629H176.698Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.698 68.0629C168.212 68.0629 161.333 74.9417 161.333 83.4273V144.885H23.0538C14.5683 144.885 7.68945 151.764 7.68945 160.249V283.164C7.68945 291.65 14.5683 298.529 23.0539 298.529H222.791C231.276 298.529 238.155 291.65 238.155 283.164V167.953C238.155 167.946 238.155 167.939 238.155 167.931L238.155 160.249L238.155 83.4273C238.155 74.9417 231.276 68.0629 222.791 68.0629H176.698Z"
      fill="#8F613C"
    />
    <path
      d="M161.333 144.885V146.421H162.87V144.885H161.333ZM238.155 167.931H239.692H238.155ZM238.155 160.249H236.619H238.155ZM238.155 83.4273H239.692H238.155ZM162.87 83.4273C162.87 75.7903 169.061 69.5993 176.698 69.5993V66.5264C167.364 66.5264 159.797 74.0932 159.797 83.4273H162.87ZM162.87 144.885V83.4273H159.797V144.885H162.87ZM23.0538 146.421H161.333V143.348H23.0538V146.421ZM9.22589 160.249C9.22589 152.612 15.4169 146.421 23.0538 146.421V143.348C13.7198 143.348 6.15301 150.915 6.15301 160.249H9.22589ZM9.22589 283.164V160.249H6.15301V283.164H9.22589ZM23.0539 296.992C15.4169 296.992 9.22589 290.801 9.22589 283.164H6.15301C6.15301 292.498 13.7198 300.065 23.0539 300.065V296.992ZM222.791 296.992H23.0539V300.065H222.791V296.992ZM236.619 283.164C236.619 290.801 230.428 296.992 222.791 296.992V300.065C232.125 300.065 239.692 292.498 239.692 283.164H236.619ZM236.619 167.953V283.164H239.692V167.953H236.619ZM236.619 167.931C236.619 167.934 236.619 167.937 236.619 167.941C236.619 167.944 236.619 167.949 236.619 167.953H239.692C239.692 167.951 239.692 167.948 239.692 167.944C239.692 167.94 239.692 167.936 239.692 167.931H236.619ZM236.619 160.249L236.619 167.931H239.692L239.692 160.249H236.619ZM236.619 83.4273L236.619 160.249H239.692L239.692 83.4273H236.619ZM222.791 69.5993C230.428 69.5993 236.619 75.7903 236.619 83.4273H239.692C239.692 74.0932 232.125 66.5264 222.791 66.5264V69.5993ZM176.698 69.5993H222.791V66.5264H176.698V69.5993Z"
      fill="black"
      mask="url(#path-3-inside-22)"
    />
    <mask id="path-5-inside-33" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.698 30.0272C168.212 30.0272 161.333 36.9061 161.333 45.3916V106.849H23.0538C14.5683 106.849 7.68945 113.728 7.68945 122.214V245.129C7.68945 253.614 14.5683 260.493 23.0539 260.493H222.791C231.276 260.493 238.155 253.614 238.155 245.129V129.918C238.155 129.91 238.155 129.903 238.155 129.896L238.155 122.214L238.155 45.3916C238.155 36.9061 231.276 30.0272 222.791 30.0272H176.698Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.698 30.0272C168.212 30.0272 161.333 36.9061 161.333 45.3916V106.849H23.0538C14.5683 106.849 7.68945 113.728 7.68945 122.214V245.129C7.68945 253.614 14.5683 260.493 23.0539 260.493H222.791C231.276 260.493 238.155 253.614 238.155 245.129V129.918C238.155 129.91 238.155 129.903 238.155 129.896L238.155 122.214L238.155 45.3916C238.155 36.9061 231.276 30.0272 222.791 30.0272H176.698Z"
      fill="#E1B185"
    />
    <path
      d="M161.333 106.849V108.386H162.87V106.849H161.333ZM238.155 129.896H239.692H238.155ZM238.155 122.214H236.619H238.155ZM238.155 45.3916H239.692H238.155ZM162.87 45.3916C162.87 37.7547 169.061 31.5637 176.698 31.5637V28.4908C167.364 28.4908 159.797 36.0575 159.797 45.3916H162.87ZM162.87 106.849V45.3916H159.797V106.849H162.87ZM23.0538 108.386H161.333V105.313H23.0538V108.386ZM9.22589 122.214C9.22589 114.577 15.4169 108.386 23.0538 108.386V105.313C13.7198 105.313 6.15301 112.88 6.15301 122.214H9.22589ZM9.22589 245.129V122.214H6.15301V245.129H9.22589ZM23.0539 258.957C15.4169 258.957 9.22589 252.766 9.22589 245.129H6.15301C6.15301 254.463 13.7198 262.03 23.0539 262.03V258.957ZM222.791 258.957H23.0539V262.03H222.791V258.957ZM236.619 245.129C236.619 252.766 230.428 258.957 222.791 258.957V262.03C232.125 262.03 239.692 254.463 239.692 245.129H236.619ZM236.619 129.918V245.129H239.692V129.918H236.619ZM236.619 129.896C236.619 129.898 236.619 129.901 236.619 129.905C236.619 129.909 236.619 129.913 236.619 129.918H239.692C239.692 129.915 239.692 129.912 239.692 129.908C239.692 129.905 239.692 129.9 239.692 129.896H236.619ZM236.619 122.214L236.619 129.896H239.692L239.692 122.214H236.619ZM236.619 45.3916L236.619 122.214H239.692L239.692 45.3916H236.619ZM222.791 31.5637C230.428 31.5637 236.619 37.7546 236.619 45.3916H239.692C239.692 36.0575 232.125 28.4908 222.791 28.4908V31.5637ZM176.698 31.5637H222.791V28.4908H176.698V31.5637Z"
      fill="black"
      mask="url(#path-5-inside-33)"
    />
    <rect
      width="7.6822"
      height="34.7612"
      transform="matrix(-1 0 0 1 96.0791 186.958)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinejoin="round"
    />
    <mask
      id="path-8-outside-4"
      maskUnits="userSpaceOnUse"
      x="77.9463"
      y="172.881"
      width="29"
      height="44"
      fill="black"
    >
      <rect fill="white" x="77.9463" y="172.881" width="29" height="44" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.2378 174.881L92.2378 174.881V174.881L104.529 196.775L95.6947 194.471L100.304 197.928L104.529 205.226L95.6947 202.921L99.9199 205.994L104.529 214.444L92.2378 214.444L92.2377 214.444L79.9463 214.444L84.5556 205.994L88.7808 202.921L79.9463 205.226L84.1715 197.928L88.7808 194.471L79.9463 196.775L92.2377 174.881V174.881L92.2378 174.881Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.2378 174.881L92.2378 174.881V174.881L104.529 196.775L95.6947 194.471L100.304 197.928L104.529 205.226L95.6947 202.921L99.9199 205.994L104.529 214.444L92.2378 214.444L92.2377 214.444L79.9463 214.444L84.5556 205.994L88.7808 202.921L79.9463 205.226L84.1715 197.928L88.7808 194.471L79.9463 196.775L92.2377 174.881V174.881L92.2378 174.881Z"
      fill="#009B47"
    />
    <path
      d="M92.2378 174.881H93.7742C93.7742 174.181 93.3015 173.57 92.6243 173.394C91.9471 173.218 91.2366 173.522 90.8958 174.133L92.2378 174.881ZM92.2378 174.881L90.9004 175.638C91.1738 176.121 91.687 176.419 92.2424 176.418C92.7979 176.416 93.3092 176.115 93.5797 175.629L92.2378 174.881ZM92.2378 174.881H90.7014C90.7014 175.145 90.7691 175.404 90.8981 175.633L92.2378 174.881ZM104.529 196.775L104.141 198.262C104.738 198.418 105.369 198.202 105.746 197.714C106.122 197.226 106.171 196.561 105.869 196.023L104.529 196.775ZM95.6947 194.471L96.0825 192.984C95.3721 192.799 94.6297 193.142 94.3108 193.803C93.9919 194.465 94.1854 195.259 94.7729 195.7L95.6947 194.471ZM100.304 197.928L101.634 197.158C101.53 196.979 101.391 196.823 101.226 196.699L100.304 197.928ZM104.529 205.226L104.141 206.712C104.741 206.869 105.376 206.65 105.752 206.156C106.127 205.663 106.17 204.992 105.859 204.456L104.529 205.226ZM95.6947 202.921L96.0825 201.434C95.3679 201.248 94.6218 201.596 94.3059 202.264C93.99 202.931 94.1938 203.729 94.791 204.164L95.6947 202.921ZM99.9199 205.994L101.269 205.258C101.16 205.058 101.008 204.885 100.824 204.751L99.9199 205.994ZM104.529 214.444V215.981C105.072 215.981 105.574 215.695 105.85 215.229C106.127 214.762 106.138 214.185 105.878 213.709L104.529 214.444ZM92.2378 214.444L92.2378 212.908C92.2122 212.908 92.1866 212.909 92.1611 212.91L92.2378 214.444ZM92.2377 214.444L92.2377 215.981C92.2633 215.981 92.2889 215.98 92.3145 215.979L92.2377 214.444ZM79.9463 214.444L78.5975 213.709C78.3378 214.185 78.3483 214.762 78.6251 215.229C78.9019 215.695 79.404 215.981 79.9463 215.981L79.9463 214.444ZM84.5556 205.994L83.6519 204.751C83.4678 204.885 83.3158 205.058 83.2068 205.258L84.5556 205.994ZM88.7808 202.921L89.6845 204.164C90.2818 203.729 90.4855 202.931 90.1696 202.264C89.8537 201.596 89.1076 201.248 88.393 201.434L88.7808 202.921ZM79.9463 205.226L78.6166 204.456C78.306 204.992 78.3482 205.663 78.7237 206.156C79.0992 206.65 79.7343 206.869 80.3341 206.712L79.9463 205.226ZM84.1715 197.928L83.2496 196.699C83.0842 196.823 82.9455 196.979 82.8418 197.158L84.1715 197.928ZM88.7808 194.471L89.7027 195.7C90.2901 195.259 90.4837 194.465 90.1647 193.803C89.8458 193.142 89.1035 192.799 88.393 192.984L88.7808 194.471ZM79.9463 196.775L78.6065 196.023C78.3049 196.561 78.3534 197.226 78.7299 197.714C79.1063 198.202 79.7379 198.418 80.3341 198.262L79.9463 196.775ZM92.2377 174.881L93.5775 175.633C93.7064 175.404 93.7742 175.145 93.7742 174.881H92.2377ZM92.2377 174.881L93.5751 174.125C93.2315 173.517 92.5216 173.218 91.8467 173.395C91.1717 173.573 90.7013 174.183 90.7013 174.881H92.2377ZM90.8958 174.133L90.8958 174.133L93.5797 175.629L93.5798 175.629L90.8958 174.133ZM93.7742 174.881V174.881H90.7014V174.881H93.7742ZM90.8981 175.633L103.189 197.528L105.869 196.023L93.5776 174.129L90.8981 175.633ZM104.917 195.289L96.0825 192.984L95.3069 195.957L104.141 198.262L104.917 195.289ZM94.7729 195.7L99.3822 199.157L101.226 196.699L96.6166 193.242L94.7729 195.7ZM98.9744 198.698L103.2 205.996L105.859 204.456L101.634 197.158L98.9744 198.698ZM104.917 203.739L96.0825 201.434L95.3069 204.408L104.141 206.712L104.917 203.739ZM94.791 204.164L99.0162 207.237L100.824 204.751L96.5984 201.679L94.791 204.164ZM98.5711 206.73L103.18 215.18L105.878 213.709L101.269 205.258L98.5711 206.73ZM104.529 212.908L92.2378 212.908L92.2378 215.981L104.529 215.981V212.908ZM92.1611 212.91L92.161 212.91L92.3145 215.979L92.3145 215.979L92.1611 212.91ZM79.9463 215.981L92.2377 215.981L92.2377 212.908L79.9463 212.908L79.9463 215.981ZM83.2068 205.258L78.5975 213.709L81.2951 215.18L85.9044 206.73L83.2068 205.258ZM87.8771 201.679L83.6519 204.751L85.4593 207.237L89.6845 204.164L87.8771 201.679ZM80.3341 206.712L89.1686 204.408L88.393 201.434L79.5585 203.739L80.3341 206.712ZM82.8418 197.158L78.6166 204.456L81.276 205.996L85.5012 198.698L82.8418 197.158ZM87.859 193.242L83.2496 196.699L85.0934 199.157L89.7027 195.7L87.859 193.242ZM80.3341 198.262L89.1686 195.957L88.393 192.984L79.5585 195.289L80.3341 198.262ZM90.898 174.129L78.6065 196.023L81.286 197.528L93.5775 175.633L90.898 174.129ZM93.7742 174.881V174.881H90.7013V174.881H93.7742ZM90.9003 175.637L90.9004 175.638L93.5751 174.125L93.5751 174.125L90.9003 175.637Z"
      fill="black"
      mask="url(#path-8-outside-4)"
    />
    <path
      d="M23.0544 297.761L22.2861 259.35H23.8226L23.0544 297.761Z"
      fill="black"
    />
    <path
      d="M222.791 297.761L222.022 259.35H223.559L222.791 297.761Z"
      fill="black"
    />
    <rect
      x="143.2"
      y="166.513"
      width="36.8745"
      height="47.5116"
      rx="6.91398"
      fill="#8F613C"
      stroke="black"
      strokeWidth="1.53644"
    />
    <path
      d="M143.251 177.268C143.251 173.45 146.346 170.354 150.165 170.354H173.211C177.03 170.354 180.125 173.45 180.125 177.268V297.761H143.251V177.268Z"
      fill="#2253E7"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="180.125"
      y="215.561"
      width="13.828"
      height="6.14576"
      transform="rotate(90 180.125 215.561)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="149.397"
      y="215.561"
      width="13.828"
      height="6.14576"
      transform="rotate(90 149.397 215.561)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="172.443"
      y="215.561"
      width="13.828"
      height="6.14576"
      transform="rotate(90 172.443 215.561)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="164.761"
      y="215.561"
      width="13.828"
      height="6.14576"
      transform="rotate(90 164.761 215.561)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="157.078"
      y="215.561"
      width="13.828"
      height="6.14576"
      transform="rotate(90 157.078 215.561)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
    />
    <rect
      x="143.391"
      y="230.157"
      width="36.3581"
      height="7.6822"
      fill="black"
      fillOpacity="0.2"
    />
    <rect
      x="142.496"
      y="254.96"
      width="1.52249"
      height="8.53312"
      fill="black"
    />
    <rect
      x="179.372"
      y="256.242"
      width="1.52249"
      height="8.53312"
      fill="black"
    />
    <path
      d="M93.3132 126.573H70.2666V118.385L78.5775 111.661V103.527H85.9454L93.3132 110.305V126.573Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinecap="round"
    />
    <rect
      x="70.9492"
      y="118.761"
      width="21.6545"
      height="7.15419"
      fill="#986F4D"
    />
    <path
      d="M99.2682 125.807V125.489L99.0432 125.264L95.5741 121.795L95.3491 121.57H95.0309H90.1742H89.856L89.631 121.795L86.1619 125.264L85.9369 125.489V125.807V129.276V130.044H86.7051H98.5H99.2682V129.276V125.807Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinecap="round"
    />
    <rect
      x="86.7051"
      y="125.876"
      width="11.7949"
      height="3.39971"
      fill="#986F4D"
    />
    <path
      d="M180.583 41.0754V40.7572L180.808 40.5322L187.586 33.7538L187.811 33.5288H188.129H197.619H197.937L198.162 33.7538L204.941 40.5322L205.166 40.7572V41.0754V47.8538V48.622H204.397H181.351H180.583V47.8538V41.0754Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinecap="round"
    />
    <rect
      width="23.0466"
      height="6.64284"
      transform="matrix(-1 0 0 1 204.398 41.2109)"
      fill="#986F4D"
    />
    <rect
      width="7.6822"
      height="34.7612"
      transform="matrix(-1 0 0 1 211.312 14.1082)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinejoin="round"
    />
    <mask
      id="path-29-outside-5"
      maskUnits="userSpaceOnUse"
      x="193.18"
      y="0.0317383"
      width="29"
      height="44"
      fill="black"
    >
      <rect fill="white" x="193.18" y="0.0317383" width="29" height="44" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.471 2.03174V41.5951H195.18L199.789 33.1446L204.014 30.0718L195.18 32.3764L199.405 25.0783L204.014 21.6213L195.18 23.926L207.471 2.03174ZM207.472 2.03175V41.5951H219.763L215.154 33.1446L210.929 30.0718L219.763 32.3764L215.538 25.0783L210.929 21.6213L219.763 23.926L207.472 2.03175Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M207.471 2.03174V41.5951H195.18L199.789 33.1446L204.014 30.0718L195.18 32.3764L199.405 25.0783L204.014 21.6213L195.18 23.926L207.471 2.03174ZM207.472 2.03175V41.5951H219.763L215.154 33.1446L210.929 30.0718L219.763 32.3764L215.538 25.0783L210.929 21.6213L219.763 23.926L207.472 2.03175Z"
      fill="#009B47"
    />
    <path
      d="M207.471 41.5951V43.1315C208.32 43.1315 209.008 42.4436 209.008 41.5951H207.471ZM207.471 2.03174H209.008C209.008 1.3329 208.536 0.72209 207.86 0.545284C207.184 0.368479 206.474 0.670219 206.131 1.2796L207.471 2.03174ZM195.18 41.5951L193.831 40.8593C193.571 41.3354 193.582 41.9131 193.859 42.3793C194.135 42.8456 194.637 43.1315 195.18 43.1315V41.5951ZM199.789 33.1446L198.885 31.9021C198.701 32.0359 198.549 32.2091 198.44 32.4089L199.789 33.1446ZM204.014 30.0718L204.918 31.3143C205.515 30.88 205.719 30.0821 205.403 29.4146C205.087 28.747 204.341 28.3987 203.626 28.5851L204.014 30.0718ZM195.18 32.3764L193.85 31.6066C193.539 32.1431 193.582 32.8137 193.957 33.307C194.333 33.8003 194.968 34.0196 195.568 33.8631L195.18 32.3764ZM199.405 25.0783L198.483 23.8492C198.318 23.9733 198.179 24.1295 198.075 24.3085L199.405 25.0783ZM204.014 21.6213L204.936 22.8505C205.523 22.4099 205.717 21.6153 205.398 20.954C205.079 20.2926 204.337 19.9493 203.626 20.1347L204.014 21.6213ZM195.18 23.926L193.84 23.1739C193.538 23.7112 193.587 24.3768 193.963 24.8646C194.34 25.3525 194.971 25.5682 195.568 25.4127L195.18 23.926ZM207.472 41.5951H205.935C205.935 42.4436 206.623 43.1315 207.472 43.1315V41.5951ZM207.472 2.03175L208.811 1.27961C208.469 0.670228 207.759 0.368488 207.083 0.545293C206.407 0.722099 205.935 1.33291 205.935 2.03175H207.472ZM219.763 41.5951V43.1315C220.305 43.1315 220.808 42.8456 221.084 42.3794C221.361 41.9131 221.372 41.3354 221.112 40.8593L219.763 41.5951ZM215.154 33.1446L216.503 32.4089C216.394 32.2091 216.242 32.036 216.058 31.9021L215.154 33.1446ZM210.929 30.0718L211.316 28.5851C210.602 28.3987 209.856 28.747 209.54 29.4146C209.224 30.0821 209.428 30.88 210.025 31.3143L210.929 30.0718ZM219.763 32.3764L219.375 33.8631C219.975 34.0196 220.61 33.8003 220.986 33.307C221.361 32.8137 221.403 32.1431 221.093 31.6066L219.763 32.3764ZM215.538 25.0783L216.868 24.3085C216.764 24.1295 216.625 23.9733 216.46 23.8492L215.538 25.0783ZM210.929 21.6213L211.316 20.1347C210.606 19.9493 209.864 20.2926 209.545 20.954C209.226 21.6153 209.419 22.4099 210.007 22.8505L210.929 21.6213ZM219.763 23.926L219.375 25.4127C219.972 25.5682 220.603 25.3525 220.98 24.8646C221.356 24.3768 221.405 23.7112 221.103 23.1739L219.763 23.926ZM209.008 41.5951V2.03174H205.935V41.5951H209.008ZM195.18 43.1315H207.471V40.0586H195.18V43.1315ZM198.44 32.4089L193.831 40.8593L196.529 42.3308L201.138 33.8804L198.44 32.4089ZM203.111 28.8292L198.885 31.9021L200.693 34.3872L204.918 31.3143L203.111 28.8292ZM195.568 33.8631L204.402 31.5584L203.626 28.5851L194.792 30.8897L195.568 33.8631ZM198.075 24.3085L193.85 31.6066L196.509 33.1462L200.735 25.8481L198.075 24.3085ZM203.092 20.3922L198.483 23.8492L200.327 26.3075L204.936 22.8505L203.092 20.3922ZM195.568 25.4127L204.402 23.108L203.626 20.1347L194.792 22.4393L195.568 25.4127ZM206.131 1.2796L193.84 23.1739L196.519 24.6781L208.811 2.78388L206.131 1.2796ZM209.008 41.5951V2.03175H205.935V41.5951H209.008ZM219.763 40.0586H207.472V43.1315H219.763V40.0586ZM213.805 33.8804L218.414 42.3308L221.112 40.8593L216.503 32.4089L213.805 33.8804ZM210.025 31.3143L214.25 34.3872L216.058 31.9021L211.832 28.8292L210.025 31.3143ZM220.151 30.8897L211.316 28.5851L210.541 31.5585L219.375 33.8631L220.151 30.8897ZM214.208 25.8481L218.433 33.1462L221.093 31.6066L216.868 24.3085L214.208 25.8481ZM210.007 22.8505L214.616 26.3075L216.46 23.8492L211.851 20.3922L210.007 22.8505ZM220.151 22.4393L211.316 20.1347L210.541 23.108L219.375 25.4127L220.151 22.4393ZM206.132 2.78389L218.423 24.6781L221.103 23.1739L208.811 1.27961L206.132 2.78389Z"
      fill="black"
      mask="url(#path-29-outside-5)"
    />
    <rect
      width="7.6822"
      height="34.7612"
      transform="matrix(-1 0 0 1 170.596 117.818)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinejoin="round"
    />
    <mask
      id="path-32-outside-6"
      maskUnits="userSpaceOnUse"
      x="152.464"
      y="103.741"
      width="29"
      height="44"
      fill="black"
    >
      <rect fill="white" x="152.464" y="103.741" width="29" height="44" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.755 145.305L154.464 145.305L159.073 136.854L163.298 133.781L154.464 136.086L158.689 128.788L163.298 125.331L154.464 127.636L166.755 105.742V105.741L166.755 105.742L166.755 105.741V105.742L179.047 127.636L170.212 125.331L174.821 128.788L179.047 136.086L170.212 133.781L174.437 136.854L179.047 145.305H166.755Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.755 145.305L154.464 145.305L159.073 136.854L163.298 133.781L154.464 136.086L158.689 128.788L163.298 125.331L154.464 127.636L166.755 105.742V105.741L166.755 105.742L166.755 105.741V105.742L179.047 127.636L170.212 125.331L174.821 128.788L179.047 136.086L170.212 133.781L174.437 136.854L179.047 145.305H166.755Z"
      fill="#009B47"
    />
    <path
      d="M154.464 145.305L153.115 144.569C152.855 145.045 152.866 145.623 153.143 146.089C153.419 146.555 153.922 146.841 154.464 146.841L154.464 145.305ZM166.755 145.305L166.755 146.841H166.755V145.305ZM159.073 136.854L158.169 135.612C157.985 135.746 157.833 135.919 157.724 136.119L159.073 136.854ZM163.298 133.781L164.202 135.024C164.799 134.59 165.003 133.792 164.687 133.124C164.371 132.457 163.625 132.108 162.911 132.295L163.298 133.781ZM154.464 136.086L153.134 135.316C152.824 135.853 152.866 136.523 153.241 137.017C153.617 137.51 154.252 137.729 154.852 137.573L154.464 136.086ZM158.689 128.788L157.767 127.559C157.602 127.683 157.463 127.839 157.359 128.018L158.689 128.788ZM163.298 125.331L164.22 126.56C164.808 126.12 165.001 125.325 164.682 124.664C164.363 124.002 163.621 123.659 162.911 123.844L163.298 125.331ZM154.464 127.636L153.124 126.884C152.822 127.421 152.871 128.086 153.247 128.574C153.624 129.062 154.255 129.278 154.852 129.122L154.464 127.636ZM166.755 105.742L168.095 106.494C168.224 106.265 168.291 106.006 168.291 105.742H166.755ZM166.755 105.741L168.095 104.99C167.753 104.38 167.043 104.078 166.367 104.255C165.69 104.432 165.219 105.043 165.219 105.741H166.755ZM166.755 105.742L165.415 106.493C165.687 106.978 166.199 107.278 166.755 107.278C167.31 107.278 167.823 106.979 168.095 106.494L166.755 105.742ZM166.755 105.741H168.292C168.292 105.043 167.82 104.432 167.144 104.255C166.468 104.078 165.758 104.38 165.416 104.989L166.755 105.741ZM166.755 105.742H165.219C165.219 106.006 165.287 106.265 165.416 106.494L166.755 105.742ZM179.047 127.636L178.659 129.122C179.255 129.278 179.886 129.062 180.263 128.574C180.639 128.086 180.688 127.421 180.386 126.884L179.047 127.636ZM170.212 125.331L170.6 123.844C169.889 123.659 169.147 124.002 168.828 124.664C168.509 125.325 168.703 126.12 169.29 126.56L170.212 125.331ZM174.821 128.788L176.151 128.018C176.047 127.839 175.909 127.683 175.743 127.559L174.821 128.788ZM179.047 136.086L178.659 137.573C179.259 137.729 179.894 137.51 180.269 137.017C180.645 136.523 180.687 135.853 180.376 135.316L179.047 136.086ZM170.212 133.781L170.6 132.295C169.885 132.108 169.139 132.457 168.823 133.124C168.507 133.792 168.711 134.59 169.308 135.024L170.212 133.781ZM174.437 136.854L175.786 136.119C175.677 135.919 175.525 135.746 175.341 135.612L174.437 136.854ZM179.047 145.305V146.841C179.589 146.841 180.091 146.555 180.368 146.089C180.645 145.623 180.655 145.045 180.395 144.569L179.047 145.305ZM154.464 146.841L166.755 146.841L166.755 143.768L154.464 143.768L154.464 146.841ZM157.724 136.119L153.115 144.569L155.813 146.04L160.422 137.59L157.724 136.119ZM162.395 132.539L158.169 135.612L159.977 138.097L164.202 135.024L162.395 132.539ZM154.852 137.573L163.686 135.268L162.911 132.295L154.076 134.599L154.852 137.573ZM157.359 128.018L153.134 135.316L155.794 136.856L160.019 129.558L157.359 128.018ZM162.377 124.102L157.767 127.559L159.611 130.017L164.22 126.56L162.377 124.102ZM154.852 129.122L163.686 126.818L162.911 123.844L154.076 126.149L154.852 129.122ZM165.415 104.99L153.124 126.884L155.804 128.388L168.095 106.494L165.415 104.99ZM168.291 105.742V105.741H165.219V105.742H168.291ZM165.415 106.493L165.415 106.493L168.095 104.99L168.095 104.99L165.415 106.493ZM165.416 104.989L165.416 104.989L168.095 106.494L168.095 106.494L165.416 104.989ZM168.292 105.742V105.741H165.219V105.742H168.292ZM165.416 106.494L177.707 128.388L180.386 126.884L168.095 104.99L165.416 106.494ZM179.434 126.149L170.6 123.844L169.824 126.818L178.659 129.122L179.434 126.149ZM169.29 126.56L173.899 130.017L175.743 127.559L171.134 124.102L169.29 126.56ZM173.492 129.558L177.717 136.856L180.376 135.316L176.151 128.018L173.492 129.558ZM179.434 134.599L170.6 132.295L169.824 135.268L178.659 137.573L179.434 134.599ZM169.308 135.024L173.534 138.097L175.341 135.612L171.116 132.539L169.308 135.024ZM173.088 137.59L177.698 146.041L180.395 144.569L175.786 136.119L173.088 137.59ZM179.047 143.768H166.755V146.841H179.047V143.768Z"
      fill="black"
      mask="url(#path-32-outside-6)"
    />
    <rect
      width="6.30009"
      height="28.5073"
      transform="matrix(-1 0 0 1 157.707 124.095)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="1.53644"
      strokeLinejoin="round"
    />
    <mask
      id="path-35-outside-7"
      maskUnits="userSpaceOnUse"
      x="142.477"
      y="112.192"
      width="24"
      height="36"
      fill="black"
    >
      <rect fill="white" x="142.477" y="112.192" width="24" height="36" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.557 114.192V146.637H164.637L160.857 139.707L157.392 137.187L164.637 139.077L161.172 133.092L157.392 130.257L164.637 132.147L154.557 114.192ZM154.557 114.192V146.637H144.477L148.257 139.707L151.722 137.187L144.477 139.077L147.942 133.092L151.722 130.257L144.477 132.147L154.557 114.192Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.557 114.192V146.637H164.637L160.857 139.707L157.392 137.187L164.637 139.077L161.172 133.092L157.392 130.257L164.637 132.147L154.557 114.192ZM154.557 114.192V146.637H144.477L148.257 139.707L151.722 137.187L144.477 139.077L147.942 133.092L151.722 130.257L144.477 132.147L154.557 114.192Z"
      fill="#009B47"
    />
    <path
      d="M154.557 146.637H153.021C153.021 147.486 153.708 148.174 154.557 148.174V146.637ZM154.557 114.192L155.897 113.44C155.555 112.83 154.844 112.529 154.168 112.705C153.492 112.882 153.021 113.493 153.021 114.192H154.557ZM164.637 146.637V148.174C165.179 148.174 165.682 147.888 165.958 147.422C166.235 146.955 166.246 146.378 165.986 145.901L164.637 146.637ZM160.857 139.707L162.206 138.971C162.097 138.772 161.945 138.598 161.761 138.465L160.857 139.707ZM157.392 137.187L157.78 135.7C157.065 135.514 156.319 135.862 156.003 136.53C155.687 137.197 155.891 137.995 156.488 138.43L157.392 137.187ZM164.637 139.077L164.249 140.564C164.849 140.72 165.484 140.501 165.86 140.008C166.235 139.514 166.277 138.844 165.967 138.307L164.637 139.077ZM161.172 133.092L162.502 132.322C162.398 132.143 162.259 131.987 162.094 131.863L161.172 133.092ZM157.392 130.257L157.78 128.77C157.069 128.585 156.327 128.928 156.008 129.59C155.689 130.251 155.883 131.046 156.47 131.486L157.392 130.257ZM164.637 132.147L164.249 133.634C164.846 133.789 165.477 133.574 165.854 133.086C166.23 132.598 166.279 131.932 165.977 131.395L164.637 132.147ZM154.557 146.637V148.174C155.405 148.174 156.093 147.486 156.093 146.637H154.557ZM154.557 114.192H156.093C156.093 113.493 155.622 112.882 154.945 112.705C154.269 112.529 153.559 112.83 153.217 113.44L154.557 114.192ZM144.477 146.637L143.128 145.902C142.868 146.378 142.879 146.955 143.155 147.422C143.432 147.888 143.934 148.174 144.477 148.174V146.637ZM148.257 139.707L147.353 138.465C147.169 138.598 147.017 138.772 146.908 138.971L148.257 139.707ZM151.722 137.187L152.625 138.43C153.223 137.995 153.426 137.197 153.11 136.53C152.795 135.862 152.048 135.514 151.334 135.7L151.722 137.187ZM144.477 139.077L143.147 138.307C142.836 138.844 142.879 139.514 143.254 140.008C143.629 140.501 144.265 140.72 144.864 140.564L144.477 139.077ZM147.942 133.092L147.02 131.863C146.854 131.987 146.716 132.143 146.612 132.322L147.942 133.092ZM151.722 130.257L152.644 131.486C153.231 131.046 153.425 130.251 153.106 129.59C152.787 128.928 152.044 128.585 151.334 128.77L151.722 130.257ZM144.477 132.147L143.137 131.395C142.835 131.932 142.884 132.598 143.26 133.086C143.637 133.574 144.268 133.789 144.864 133.634L144.477 132.147ZM156.093 146.637V114.192H153.021V146.637H156.093ZM164.637 145.101H154.557V148.174H164.637V145.101ZM159.508 140.443L163.288 147.373L165.986 145.901L162.206 138.971L159.508 140.443ZM156.488 138.43L159.953 140.95L161.761 138.465L158.296 135.945L156.488 138.43ZM165.025 137.59L157.78 135.7L157.004 138.674L164.249 140.564L165.025 137.59ZM159.842 133.862L163.308 139.847L165.967 138.307L162.502 132.322L159.842 133.862ZM156.47 131.486L160.25 134.321L162.094 131.863L158.314 129.028L156.47 131.486ZM165.025 130.66L157.78 128.77L157.004 131.744L164.249 133.634L165.025 130.66ZM153.217 114.944L163.297 132.899L165.977 131.395L155.897 113.44L153.217 114.944ZM156.093 146.637V114.192H153.02V146.637H156.093ZM144.477 148.174H154.557V145.101H144.477V148.174ZM146.908 138.971L143.128 145.902L145.825 147.373L149.605 140.443L146.908 138.971ZM150.818 135.945L147.353 138.465L149.16 140.95L152.625 138.43L150.818 135.945ZM144.864 140.564L152.109 138.674L151.334 135.7L144.089 137.59L144.864 140.564ZM146.612 132.322L143.147 138.307L145.806 139.847L149.271 133.862L146.612 132.322ZM150.8 129.028L147.02 131.863L148.863 134.321L152.644 131.486L150.8 129.028ZM144.864 133.634L152.109 131.744L151.334 128.77L144.089 130.66L144.864 133.634ZM153.217 113.44L143.137 131.395L145.816 132.899L155.896 114.944L153.217 113.44Z"
      fill="black"
      mask="url(#path-35-outside-7)"
    />
    <mask
      id="mask0"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="144"
      y="254"
      width="36"
      height="12"
    >
      <rect
        x="179.444"
        y="265.375"
        width="35.4442"
        height="11.3746"
        transform="rotate(-180 179.444 265.375)"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M182.371 254.982L175.878 261.476L172.339 257.899L168.8 261.476L165.261 257.899L161.722 261.476L158.183 257.899L154.644 261.476L151.105 257.899L147.566 261.476L140.506 254.416"
        stroke="#63B4FF"
        strokeWidth="4.62316"
      />
    </g>
    <mask
      id="mask1"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="144"
      y="292"
      width="36"
      height="12"
    >
      <rect
        x="179.444"
        y="304"
        width="35.4442"
        height="11.3746"
        transform="rotate(-180 179.444 304)"
        fill="#0B6FFB"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        d="M182.371 293.608L175.878 300.101L172.339 296.524L168.8 300.101L165.261 296.524L161.722 300.101L158.183 296.524L154.644 300.101L151.105 296.524L147.566 300.101L140.506 293.041"
        stroke="#0B6FFB"
        strokeWidth="4.62316"
      />
    </g>

    <IslandLabel
      levelText="Level 2"
      titleText="Python"
      x={68}
      y={119}
      styles={styles}
    />
  </svg>
);

PythonIsland.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  styles: PropTypes.object.isRequired,
  scale: PropTypes.number,
};

export default PythonIsland;
